import { useAuth } from '@/features/auth/authContext'

const CATALOGUE_ROLES: ReadonlySet<string> = new Set(['company_admin'])

export function roleCanEditCatalogue(roleKey: string | undefined): boolean {
  return roleKey !== undefined && CATALOGUE_ROLES.has(roleKey)
}

/**
 * Keeping the catalogue from a Standort is `CATALOG_EDIT`, held by
 * `company_admin` only; a `franchise_partner` asks for its own prices through
 * Preisanfragen instead, and the Standort roles get a 403 `CAPABILITY_REQUIRED`.
 * The platform operator keeps it in the platform area.
 *
 * This hides the entry; it does not replace handling the 403. The server
 * decides, and a role can change under a tab that has been open for hours.
 */
export function useCanEditCatalogue(): boolean {
  const { role } = useAuth()
  return roleCanEditCatalogue(role?.key)
}
